import React from 'react'
import { Alert } from 'react-bootstrap'

import { FailedSpotRetry } from './FailedSpotRetry'
import { ShiftSelectStep } from './ShiftSelectStep'
import { SpotDecisionStep } from './SpotDecisionStep'
import { CancelStep } from './types'

// Which body the dialog shows: a load error, the loading row, step 1, the post-failure
// retry, or step 2. Extracted so the container's render is a flat Modal + one component
// instead of a five-way nested ternary.
export const ModalBody = ({
  loadError,
  loading,
  step,
  failedSpotShiftIds,
  selectStepProps,
  spotDecisionStepProps,
}: {
  loadError?: string
  loading: boolean
  step: CancelStep
  failedSpotShiftIds: number[]
  selectStepProps: React.ComponentProps<typeof ShiftSelectStep>
  spotDecisionStepProps: React.ComponentProps<typeof SpotDecisionStep>
}) => {
  if (loadError) {
    return <Alert bsStyle="danger">{loadError}</Alert>
  }
  if (loading) {
    return <div className="loading-row">Loading this worker\u2019s bookings\u2026</div>
  }
  if (step === 'select') {
    return <ShiftSelectStep {...selectStepProps} />
  }
  if (failedSpotShiftIds.length > 0) {
    const { count, worker, reason, reasonLabel } = spotDecisionStepProps

    return (
      <FailedSpotRetry
        count={count}
        worker={worker}
        reason={reason}
        reasonLabel={reasonLabel}
        failedSpotShiftIds={failedSpotShiftIds}
      />
    )
  }

  return <SpotDecisionStep {...spotDecisionStepProps} />
}
